module.exports = __webpack_public_path__ + "static/media/logos2.96003e52.png";